export function isValidCarRegistration(input: string): boolean {
  return /^[A-Z]{1,2}[0-9]{1,2}\s?[A-Z]{3}$/i.test(input.replace(/\s+/g, ''))
}

export function formatCarDetails(
  make: string,
  model: string,
  vrm: string,
): string {
  return `${make.toLocaleLowerCase()} ${model.toLocaleLowerCase()} (${vrm
    .replace(/\s+/g, '')
    .toUpperCase()})`
}

export function splitVariantDescription(description: string): {
  model: string
  rest: string
} {
  const model = description.split(' ')[0]
  const rest = description.slice(model.length).trim()
  return { model, rest }
}

export function normalizeVrm(vrm: string | undefined | null): string {
  return (vrm || '').replace(/\s+/g, '').toUpperCase()
}

export const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
